import { Vue, Component } from 'vue-property-decorator';
import { useNosnippet } from '@common/util';
import {
    Getter
} from 'vuex-class';

@Component({
    name: 'MobileShareUserLayout',
})
export default class MobileShareUserLayout extends Vue {
  @Getter('initMetaData') initMetaData?: string;

  @Getter('initData') initData?: Record<string, any>;

  @Getter('localLang') localLang?: Record<string, any>;

  isNode: boolean = EASY_ENV_IS_NODE;

  locale: string = '';
  
  dir: string = 'ltr';

  useNosnippet: boolean = false;

  created() {
      this.$store.dispatch('getInitMetaData');
      this.$store.dispatch('getInitData');
      this.$store.dispatch('getLocalLang');
      const initPageData = this.initData;
      this.locale = initPageData?.locale || '';

      this.useNosnippet = useNosnippet(initPageData?.query?.source);

      const isRtl = initPageData?.isRtl;
      this.dir = isRtl ? 'rtl' : 'ltr';
  }
}